// extracted by mini-css-extract-plugin
export default {"wrapper":"B3wf_17C0Tv1BtOOHhOo"};